import React, { useState } from "react";
import PageLayout from "../../../components/PageLayout";
import jeyedaUsersHelp from "../../../content/help/jeyeda-users.json";
import JeyedaUsersTable from "./JeyedaUsersTable";
import { AddUserDialog, EditRoleDialog } from "./JeyedaUsersDialogs";
import {
  fetchUsers,
  createUser,
  updateUserRole,
  deleteUser,
} from "./JeyedaUsersAPI";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import { extractMsg } from "../../../utils/errorUtils";

export default function JeyedaUsers({ pageTitle = "Jeyeda Users" }) {
  usePageTitle("Jeyeda Users - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchUsers,
    filterFields: ["username", "email"],
  });

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editRoleModalOpen, setEditRoleModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const isRoleUser = useIsRoleUser();

  const handleAddUser = async (values) => {
    try {
      await createUser(values);
      messageApi.success("User added successfully");
      loadData();
    } catch (error) {
      throw error;
    }
  };

  const handleEditRole = async (userId, role) => {
    try {
      await updateUserRole(userId, role);
      messageApi.success("User role updated successfully");
      loadData();
    } catch (error) {
      throw error;
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      await deleteUser(userId);
      messageApi.success("User deleted successfully");
      loadData();
    } catch (error) {
      messageApi.error(extractMsg(error, "Failed to delete user"));
    }
  };

  return (
    <div className="jeyeda-users-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logoSrc="/img/Jeyeda_logo_no_text.png"
        description="Manager for Jeyeda Users, allowing you to create, edit and delete users and organize your user accounts in one place."
        helpContent={jeyedaUsersHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
          addButtonLabel="Add User"
          onAdd={() => setAddModalOpen(true)}
          showAdd={!isRoleUser}
        />

        <JeyedaUsersTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onEditRole={(user) => {
            setSelectedUser(user);
            setEditRoleModalOpen(true);
          }}
          onDeleteUser={handleDeleteUser}
          isRoleUser={isRoleUser}
        />

        <AddUserDialog
          open={addModalOpen}
          onClose={() => setAddModalOpen(false)}
          onSave={handleAddUser}
        />
        <EditRoleDialog
          open={editRoleModalOpen}
          user={selectedUser}
          onClose={() => setEditRoleModalOpen(false)}
          onSave={handleEditRole}
        />
      </PageLayout>
    </div>
  );
}
